
import {
    JsonItem
} from "../../shared/entities/pick-list/pick-list.entities";

import { CabHubConnectionEditController, CabHubConnectionFormController } from "./cab-hub-tracking.controller";

import {
    CabHubCompletedSurveyRow, CabHubConnectionEntity, CabHubScope
} from "./cab-hub-tracking.entities";
import { CabHubCompletedSurveysTable } from "./cab-hub-tracking.table";


export type CabHubConnectionDetailsVm = {
    Id:
    number;

    Status:
    string;

    DocumentUploadId:
    string;

    SurveyHistory:
    CabHubCompletedSurveyRow[];

    PickLists:
    JsonItem[];
    Connection:
    CabHubConnectionEntity;
    Scope: CabHubScope;
};


export class CabHubConnectionDetailsPage { 
    

  
    private readonly connectionForm:
        CabHubConnectionFormController;

    private readonly connectionEdit:
        CabHubConnectionEditController;

    private readonly surveyHistoryTable:
        CabHubCompletedSurveysTable;

    constructor(
        private readonly vm:
            CabHubConnectionDetailsVm

    ) {
        this.surveyHistoryTable =
            new CabHubCompletedSurveysTable(
                this.vm.SurveyHistory,
                this.vm.Scope,
                this.vm.PickLists,
                "connection-survey-history-table"
              
            );
        this.connectionForm = new CabHubConnectionFormController(
            this.vm as any,
            "/secure/cab-hub/cab-hub-tracking"
        );
        this.connectionForm
            .initialize();

        this.connectionEdit =
            new CabHubConnectionEditController(
                this.connectionForm
            );
    

        this.initializeStatus();

        this.initializeAgreementDownload();
        $("#edit-connection-button")
            .on(
                "click",
                () => {

                    this.connectionEdit
                        .openConnection(
                            this.vm.Connection
                        );
                }
            );

        this.surveyHistoryTable
            .initialize();
    }


    private initializeStatus():
        void {

        const isActive =
            (this.vm.Status ?? "")
                .trim()
                .toLowerCase() ===
            "active";

        $("#cab-hub-connection-status")
            .addClass(
                isActive
                    ? "cab-edit-table-active-pill"
                    : "cab-detail-table-inactive-pill"
            );
    }


    private async initializeAgreementDownload():
        Promise<void> {

        const uploadId =
            this.vm.DocumentUploadId;

        if (!uploadId) {
            return;
        }

        try {
            const result: any =
                await $.ajax(
                    "/api/upload-service/get-files",
                    {
                        method:
                            "POST",

                        headers: {
                            "RequestVerificationToken":
                                String(
                                    $(
                                        'input[name="__RequestVerificationToken"]'
                                    ).val() ?? ""
                                )
                        },

                        contentType:
                            "application/json; charset=utf-8",

                        data:
                            JSON.stringify({
                                rootFolderPath:
                                    "cab-hub-uploads",

                                uuidArray: [
                                    uploadId
                                ]
                            })
                    }
                );

            const document =
                result?.items?.[0];

            if (!document) {
                $("#cab-hub-agreement-loading")
                    .text(
                        "Agreement document unavailable"
                    );

                return;
            }

            const filePath =
                encodeURI(
                    document.id
                );

            $("#cab-hub-agreement-download")
                .attr(
                    "href",
                    `/api/upload-service/download-file?filePath=${filePath}`
                )
                .attr(
                    "download",
                    document.text
                )
                .text(
                    document.text ||
                    "View agreement document"
                )
                .removeClass(
                    "d-none"
                );

            $("#cab-hub-agreement-loading")
                .remove();
        }
        catch (error) {
            console.error(
                "Unable to load agreement document:",
                error
            );

            $("#cab-hub-agreement-loading")
                .text(
                    "Agreement document unavailable"
                );
        }
    }
}

